import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { SkillsIdeateFlowData } from '@core/tellent-skills-types';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogComponentI,
  DialogRef,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-skills-ideate-error-dialog',
  templateUrl: './skills-ideate-error-dialog.component.html',
  styleUrl: './skills-ideate-error-dialog.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, DialogBodyComponent, HeadingComponent, IconComponent, TranslatePipe],
})
export class SkillsIdeateErrorDialogComponent implements DialogComponentI<
  Partial<SkillsIdeateFlowData>,
  { back: true }
> {
  private readonly dialogRef = inject(DialogRef);

  public setDialogData(_data: Partial<SkillsIdeateFlowData>, _triggerUpdate: boolean): void {
    //
  }

  public goBack(): void {
    this.dialogRef.close({ back: true });
  }

  public close(): void {
    this.dialogRef.close();
  }
}
